<style lang="sass" scoped>
  @import '../../../sass/variables'

  .card
    height: 471px
    .table-responsive
      overflow: hidden
      margin-bottom: 0

      tr
        background-color: $salesflow-bg-content

    .card-header
      h2.title
        font-size: 1.25rem
        font-weight: 700
        line-height: 120%
        color: $salesflow-font-gray

    .card-body
      padding-bottom: 0px
      td.stat-text
        font-size: 1rem
        color: $salesflow-font-dark
        line-height: normal
        font-weight: 500
        padding: 0
        padding-top: 16px
        span
          padding-top: 5px
          padding-bottom: 17px
    .card-table
      .card-body
        padding-top: 0px !important
  span
    display: block
    font-weight: 500
    margin-top: 0.25rem
    font-size: 1.5rem
    line-height: 1.75rem

  .chart-title th
    border: none
    font-weight:500
    font-size:12px
    height: 24px
    padding: 0

  .first-title
    padding:0px

  .second-title
    padding-left:23px !important

  .graphic
    padding: 0
    padding-left: 24px
    padding-top: 30px

  .dashboard-empty-data
    opacity: 1
    transition: opacity 0.5s ease-in-out
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    position: absolute
    height: 100px
    width: 90%
    max-width: 600px
    border-radius: 30px
    z-index: 2
    text-align: center
    padding: 0 20px
    box-sizing: border-box
    font-size: 1.5rem
    margin:0px

</style>

<template>
  <div
    class="card card-table with-shadow"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <div class="card-header">
      <h2 class="title float-left">
        {{ __('E-mails e engajamento') }}
      </h2>
    </div>
    <div
      class="card-body"
      :class="{ hovering }"
    >
      <div
        class="loader"
        v-if="loading"
      >
        <h2 class="text-center">
          <i class="fa fa-circle-o-notch fa-spin" />
        </h2>
      </div>
      <FakeData
        :hovering="hovering"
        cta="SAIBA MAIS SOBRE CAMPANHAS"
        href="https://salesflowcrm.movidesk.com/kb/article/404307/automacao-de-marketing"
        :zoom="0.6"
        content="Envie campanhas para seus leads e saiba quando cada um recebeu,<br> abriu ou clicou em seus e-mails."
        v-else-if="fake"
      />
      <DashboardEmptyData
        class="dashboard-empty-data"
        :content="__('Que tal enviar um e-mail agora?')"
        v-else-if="empty"
      />
      <div
        class="table-responsive"
        :class="{ disabled: loading, fake, hovering, hidden: empty }"
      >
        <table
          class="table"
          v-if="data.current"
        >
          <thead class="chart-title">
            <tr>
              <th colspan="1" class="first-title">MÊS ATUAL</th>
              <th colspan="1" class="second-title">ÚLTIMOS 6 MESES</th>
            </tr>
          </thead>
          <tbody class="body">
            <tr
              v-for="stat in stats"
              :key="stat.id"
            >
              <td class="stat-text">{{ __(stat.name) }}<span>{{ data.current[stat.id] | number(0) }}</span></td>
              <td class="graphic">
                <Apexchart
                  width="300"
                  height="50"
                  type="area"
                  :series="data.monthly[stat.id]"
                  :options="chartOptions"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Widget from '../../mixins/widget';

export default {
  mixins: [Widget],

  data () {
    return {
      name: 'mail.stats',
      loading: true,
      hovering: false,
      fake: false,
      empty: false,
      error: false,
      data: {},
      stats: [
        { id: 'sent', name: 'Enviados' },
        { id: 'delivered', name: 'Entregues' },
        { id: 'opened', name: 'Abertos' },
        { id: 'clicked', name: 'Clicados' },
      ],
      chartOptions: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        colors: ['#5F33FF'],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0,
            opacityFrom: 0.6,
            opacityTo: 0.6,
            color: ['#B7A3FF']
          }
        },
        stroke: {
          width: 2,
          lineCap: 'round',
          curve: 'smooth',
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          fixed: {
            enabled: false,
          },
          style: {
            fontSize: '12px',
            fontFamily: 'Montserrat',
          },
          y: {
            title: {
              formatter () {
                return '';
              },
            },
          },
        },
        responsive: [{
          breakpoint: 1921,
          options: {
            chart: {
              width: 350,
              height: 55
            },
          }
        },
        {
          breakpoint: 1681,
          options: {
            chart: {
              width: 300
            },
          }
        },
        {
          breakpoint: 1601,
          options: {
            chart: {
              width: 270,
            },
          }
        },
        {
          breakpoint: 1441,
          options: {
            chart: {
              width: 220,
              height: 40
            },
          }
        },
        {
          breakpoint: 1401,
          options: {
            chart: {
              width: 210,
              height: 40
            },
          }
        },
        {
          breakpoint: 1367,
          options: {
            chart: {
              width: 200,
              height: 40
            },
          }
        },
        {
          breakpoint: 1281,
          options: {
            chart: {
              width: 140,
              height: 40
            },
          }
        },
        {
          breakpoint: 1180,
          options: {
            chart: {
              width: 130,
              height: 40
            },
          }
        },
        {
          breakpoint: 1120,
          options: {
            chart: {
              width: 110,
              height: 40
            },
          }
        }
        ]
      },
    };
  },

  watch: {
    loading () {
      this.fake = false;
      this.empty = false;

      if (this.data.fake === true) {
        this.useFakeData();
      } else if (this.dataIsEmpty()) {
        this.empty = true;
      }

      if (this.data.categories && Array.isArray(this.data.categories)) {
        this.updateChartOptions();
      }
    },
  },

  methods: {
    updateChartOptions() {
      const newOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: this.data.categories,
          type: 'datetime',
          labels: {
            formatter: (value) => {
              const date = new Date(value);
              const month = date.toLocaleString('pt-BR', { month: 'long' });
              const year = date.getFullYear();
              return `${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`;
            }
          }
        }
      };

      this.chartOptions = newOptions;
    },

    dataIsEmpty () {
      return ! this.data.current;
    },

    useFakeData () {
      this.fake = true;

      this.data = {
        current: {
          month: '2020-02-29', delivered: '303', dropped: '6', opened: '55', clicked: '5', bounced: '0', sent: 309,
        },
        monthly: {
          delivered: [{ name: 'delivered', data: ['0', '973', '303'] }], dropped: [{ name: 'dropped', data: ['0', '11', '6'] }], opened: [{ name: 'opened', data: ['0', '231', '55'] }], clicked: [{ name: 'clicked', data: ['0', '34', '5'] }], bounced: [{ name: 'bounced', data: ['0', '3', '0'] }], sent: [{ name: 'sent', data: [0, 984, 309] }],
        },
        categories: ['2019-12-31', '2020-01-31', '2020-02-29'],
      };
    },
  },
};
</script>
